module.exports = __webpack_public_path__ + "static/logo-bfde6ab18c3ff66184a4aae5f9ae447e.png";